<!--
  AppShell Component
  Main layout: Sidebar (left) + Topbar (top) + Content (main area).
  Handles sidebar collapse state.
-->
<script lang="ts">
  import Sidebar from './Sidebar.svelte';
  import Topbar from './Topbar.svelte';

  let sidebarCollapsed = false;
</script>

<!-- --page-h: the height of the content area (viewport minus topbar h-14 and main p-6 twice), for
     pages that fill the viewport instead of scrolling as a whole. -->
<div class="flex h-screen overflow-hidden bg-bg" style="--page-h: calc(100vh - 6.5rem)">
  <!-- Sidebar -->
  <Sidebar bind:collapsed={sidebarCollapsed} />

  <!-- Main area -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <!-- Topbar -->
    <Topbar />

    <!-- Page content -->
    <main class="flex-1 overflow-y-auto p-6">
      <div class="max-w-content mx-auto">
        <slot />
      </div>
    </main>
  </div>
</div>
